/*-----------------------------------------------------------------------------
|> TVGuide Channels List Component
|------------------------------------------------------------------------------
|
| Render a list of TVGuide channels with schedule
|
-----------------------------------------------------------------------------*/
<template>
    <div class="vw-guide-channel-list guide-channel-list">
        <channel
            v-for="(channel, index) in data"
            :key="index"
            :data="channel"
            :data-index="index"
            :data-order="index"
            :start-time="startTime"
            :swipe-handler="swipeHandler"
        />
    </div>
</template>

<script>
import Channel from '@components/iptv/ChannelItem.vue';

export default {
    components: { Channel },
    props: {
        data: { type: Array, required: true },
        startTime: { type: String, required: true },
        swipeHandler: { type: Function, required: true },
    },
    mounted() {
        /** Sets initial possition of channel items */
        const channels = document.querySelectorAll('.guide-channel');

        channels.forEach((channel) => {
            channel.style.top = `${channel.offsetHeight * channel.dataset.index}px`;
        });
    },
}
</script>
